import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import en from "./en.json";

export const LANGS = [["en", "English"], ["ar", "العربية"], ["es", "Español"], ["pt", "Português"], ["th", "ไทย"], ["vi", "Tiếng Việt"], ["ur", "اردو"]];
export const CODES = LANGS.map(([c]) => c).filter((c) => c !== "en");
const RTL = ["ar", "ur"];
const FONTS = { ar: "Cairo:wght@400;500;600;700;800", ur: "Noto+Nastaliq+Urdu:wght@400;500;600;700" };
const loaders = { ar: () => Promise.all([import("./ar.json"), import("./ar_home.json")]).then(([a, h]) => { const d = a.default || a, o = h.default || h; return { ...d, home: { ...d.home, ...o.home }, categories: { ...d.categories, names: { ...d.categories.names, ...o.categoryNames } } }; }), es: () => import("./es.json"), pt: () => import("./pt.json"), th: () => import("./th.json"), vi: () => import("./vi.json"), ur: () => import("./ur.json") };
const cache = { en };
const Ctx = createContext({ lang: "en", t: en, p: (x) => x, base: "/" });

export const langOf = (pathname) => { const s = pathname.split("/")[1]; return CODES.includes(s) ? s : "en"; };
const AUTH_PATHS = ["/login", "/register", "/register/google", "/confirm-email", "/forgot-password", "/reset-password", "/verify-email"];
const DASH = /^\/(app|admin|business)(\/|$)/;
const stored = () => { const l = localStorage.getItem("rl_lang"); return CODES.includes(l) ? l : "en"; };
export const userLang = stored;
export const stripLang = (pathname) => { const l = langOf(pathname); return l === "en" ? pathname : pathname.slice(l.length + 1) || "/"; };
export const withLang = (lang, path) => (lang === "en" ? path : `/${lang}${path === "/" ? "" : path}`);

export function I18nProvider({ children }) {
  const { pathname } = useLocation();
  const isAuth = AUTH_PATHS.includes(pathname);
  const lang = isAuth ? stored() : DASH.test(pathname) ? "en" : langOf(pathname);
  const [, force] = useState(0);
  useEffect(() => {
    if (!isAuth && !DASH.test(pathname)) localStorage.setItem("rl_lang", lang);
  }, [isAuth, pathname, lang]);
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = RTL.includes(lang) ? "rtl" : "ltr";
    const font = FONTS[lang];
    if (font && !document.getElementById(`font-${lang}`)) {
      const l = document.createElement("link");
      l.id = `font-${lang}`;
      l.rel = "stylesheet";
      l.href = `https://fonts.googleapis.com/css2?family=${font}&display=swap`;
      document.head.appendChild(l);
    }
    if (!cache[lang]) loaders[lang]().then((m) => { cache[lang] = m.default || m; force((n) => n + 1); });
  }, [lang]);
  const t = cache[lang] || en;
  const setLang = (l) => { localStorage.setItem("rl_lang", l); force((n) => n + 1); };
  return <Ctx.Provider value={{ lang, t, p: (x) => withLang(lang, x), base: stripLang(pathname), setLang }}>{children}</Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
